// import moment from 'moment'
export function convertTime(time) {
    var date = new Date(Math.round(Number(time)));

    return date.getUTCDate() + '-' + (date.getUTCMonth() + 1)+ '-' + date.getUTCFullYear()
}